export default {
  title: 'צפייה במיילים של הסוכן {1}',
  label: 'צפייה במייל',
  columns: {
    name: 'שם מייל',
    date: 'תאריך',
    content: 'תוכן',
    sendType: 'סוג שליחה',
    resendReason: 'סיבת שליחה חוזרת',
    actions: 'פעולות',
  },
  sendTypes: {
    resend: 'שליחה חוזרת',
  },
  actions: {
    view: 'צפייה',
    edit: 'עריכה',
    delete: 'מחיקה',
    resend: 'שליחה חוזרת',
  },
  archive: {
    title: 'צפייה בארכיון',
    deletedAt: 'תאריך מחיקה',
  },
  edit: {
    label: 'עריכת מייל',
    subject: 'שם המייל',
    content: 'תוכן המייל',
    notice: 'העריכה מעדכנת את התיעוד במערכת בלבד ואינה משנה את המייל שכבר הגיע לתיבת הדואר של הסוכן. לאחר העריכה ניתן לשלוח לסוכן את התוכן המעודכן.',
    success: 'המייל עודכן בהצלחה',
    error: 'שגיאה בעדכון המייל',
  },
  delete: {
    label: 'מחיקת מייל',
    notice: 'המחיקה מסירה את הרשומה מהמערכת בלבד ואינה מוחקת את המייל מתיבת הדואר של הסוכן.',
    verify: 'האם את/ה בטוח/ה שברצונך למחוק את המייל?',
    reason: 'סיבת מחיקה',
    success: 'המייל נמחק בהצלחה',
    error: 'שגיאה במחיקת המייל',
  },
  resend: {
    label: 'שליחה חוזרת של מייל',
    reason: 'סיבת שליחה חוזרת',
    reasonPlaceholder: 'לדוגמה: כותרת שגויה במייל המקורי',
    subject: 'שם המייל',
    content: 'תוכן המייל',
    recipients: 'נמענים',
    recipientsPlaceholder: 'agent@example.com',
    attachments: 'קבצים מצורפים',
    addFile: 'הוספת קובץ',
    notice: 'כל שליחה חוזרת נשמרת כשורה נוספת ביומן המיילים, כך שההיסטוריה המלאה נשמרת.',
    send: 'שליחה',
    success: 'המייל נשלח בהצלחה',
    error: 'שגיאה בשליחת המייל',
  },
};
